import { ConfluencePageAri } from '@atlassian/ari';
import { getCloudId } from '@databases/database-state';
import {
  BlogpostReference,
  OptionalCreatePage,
  PageReference,
} from '@databases/types/confluence';

export const getConfluencePageAriFromContentRef = (
  content:
    | PageReference
    | BlogpostReference
    | OptionalCreatePage
    | { _id: string }
    | { contentId: string }
): string | undefined => {
  let ari: string | undefined = undefined;
  if ('ari' in content && content.ari) {
    ari = content.ari;
  } else if ('contentId' in content) {
    ari = ConfluencePageAri.create({
      siteId: getCloudId() || '',
      pageId: content.contentId!,
    }).toString();
  }

  return ari;
};
